import sumBy from 'lodash/sumBy';

import { ExposureData, ReanalysisFragment } from '@spotify/confidence-graphql';
import {
  getIsEditDisabled,
  moduleHelpers,
} from '@spotify/plugin-confidence-workflows-react';

import { ReAnalysisData } from './ReanalysisModule/types';

export const isEditDisabled = getIsEditDisabled(['archived']);

export function sumExposureCount(exposureData?: ExposureData): number {
  return sumBy(
    exposureData?.exposure || [],
    e => Number(e.totalExposureCount) || 0,
  );
}

export const tabForState = (
  workflowInstance: Pick<ReanalysisFragment, 'moduleData'>,
) => {
  const reanalysisData = moduleHelpers.getModuleData<ReAnalysisData>(
    workflowInstance.moduleData,
    'reanalysis',
  );

  const showResults =
    !reanalysisData?.configChanged &&
    reanalysisData?.exposureState &&
    reanalysisData?.exposureState !== 'STATE_UNSPECIFIED';
  return showResults ? 'result' : 'design';
};
